import { useState } from "react";
import styles from "./styles.module.css";
import { Header } from "./components/Header";
import { HeroContent } from "./components/HeroContent";
import { EnterpriseModal } from "./components/EnterpriseModal";

export const ScriberXHero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.layoutColumn}>
        <Header />
        <HeroContent onOpenModal={() => setIsModalOpen(true)} />
      </div>

      <EnterpriseModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};
